<template lang="pug">
  div(:class="(isMobile ? 'isMobile ':'isDesktop ') + (hasWidthGt1920 ? 'widthGt1920 ':'') + (isLandscape ? 'isLandscape ':'')" id="app" md-mode="reveal")
    AsuHeader(v-if="showHeader()")
    v-app
      v-btn.mobile-menu(v-show="!showMenuIcon()" fab flat fixed top left small color='primary' @click='toggleMenuVisible()' v-if='!embedded' style='z-index: 402;')
        span.ap-menu
      v-navigation-drawer.primary.mobile-menu-drawer(v-model="menuVisible" dark absolute temporary style="z-index: 10999; position: fixed;")
        v-list.pt-0(v-if="hrefify")
          template(v-for="item in navigationDrawerList")
            v-list-tile(to :href="hrefify(item.link)" :class="{ 'v-list__tile--active': item.active }" v-if="item.conditional" @click="toggleMenuVisible()")
              v-list-tile-content
                v-list-tile-title {{ item.title }}

      div(v-if="loaderConfig")
        router-view
        v-dialog(v-if="isLoad" v-model="isLoad" :hide-overlay="loaderConfig.hideOverlay" content-class="elevation-0 loader-dialog")
          div
            v-progress-circular(:size="70" :width="7" indeterminate color="primary")

</template>

<script>
import { mapGetters } from 'vuex'
import { getData } from './utils/object.js'
import resizeMixin from './mixins/resize.js'

const homeViewObj = { name: 'home' }

export default {
  name: 'app',
  mixins: [ resizeMixin ],
  computed: {
    ...mapGetters([
      'hrefify',
      'httpIsProcessing',
      'isCurrentRoute',
      'isMapView',
      'isSolucionACortoPlazo',
      'isSolucionDefinitiva',
      'loaderConfig',
      'isInProjectsView'
    ]),
    ...mapGetters({
      headerIsHidden: 'getShowHeader'
    }),
    page () {
      return getData(this.routeMeta).page
    },
    embedded () {
      return getData(this.routeMeta).embedded
    },
    isLoad () {
      return this.loadingPage || this.httpIsProcessing
    },
    isHomeView () {
      return this.$route.name === homeViewObj.name
    },
    navigationDrawerList () {
      const projectsViewObj = { name: 'projects' }
      return [
        {
          link: homeViewObj,
          title: 'Inicio',
          conditional: this.isMobile,
          active: this.isHomeView
        },
        {
          link: projectsViewObj,
          title: 'Proyectos',
          conditional: this.isMobile,
          active: this.isCurrentRoute(projectsViewObj)
        },
        {
          link: { name: 'map' },
          title: 'Solución definitiva',
          conditional: this.isMobile,
          active: this.isSolucionDefinitiva
        },
        {
          link: { name: 'map', query: { ver: 'refugios' } },
          title: 'Solución a corto plazo',
          conditional: this.isMobile,
          active: this.isSolucionACortoPlazo
        }
      ]
    }
  },
  mounted () {
    const self = this
    window.onload = () => {
      self.loadingPage = false
    }
  },
  data: () => ({
    menuVisible: false,
    loadingPage: true
  }),
  methods: {
    toggleMenuVisible () {
      this.menuVisible = !this.menuVisible
    },
    showMenuIcon () {
      return this.isMapView || this.isSolucionDefinitiva || this.isSolucionACortoPlazo || this.isInProjectsView
    },
    showHeader () {
      let isMapPage = (this.isSolucionACortoPlazo || this.isSolucionDefinitiva || this.isInProjectsView)
      return ((!isMapPage || !this.isMobile) && this.headerIsHidden)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './styles/variables'

.v-navigation-drawer
  & >>>
    .v-list .v-list__tile--active .v-list__tile.v-list__tile--link
      font-weight: bold
      color: $color_0
    .v-list__tile--link
      text-decoration: none
    .v-list__tile--active,
    .theme--dark.v-list .v-list__tile--active:hover
      background-color: white

</style>
<style lang="stylus">
@import './styles/custom-style'

.ap-menu
  color: #636368;
  font-size: 1.75rem;
.mobile-menu
  top: 40px !important;
  z-index: 1000 !important;
.v-dialog.loader-dialog
  background-color: transparent
  min-width: auto
  height: 90px
  width: 90px
.loader-dialog
  @media (max-width: 600px)
    &.md-dialog-fullscreen
      width: 60px
      height: 60px
</style>
